import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaMagic,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const GreenScreenVideoProductionInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Green Screen Video Production in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unleash Creativity</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Green Screen Video Production</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our green screen video production services in
            **Al Barsha** create dynamic, versatile videos that bring your
            vision to life. From commercials to virtual events, we use advanced
            green screen technology to craft immersive visuals with limitless
            creative possibilities.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Green screen studio
          "https://images.unsplash.com/photo-1617560611911-547e5ca6524d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production crew
          "https://images.unsplash.com/photo-1635830625698-3b9bd74671ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Post-production editing
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Green Screen Video Production in Al Barsha"
        description="We deliver versatile, high-quality videos that captivate audiences."
        cards={[
          {
            icon: <FaMagic color="#ff5464" size={40} />,
            title: "Limitless Creativity",
            description: "Custom backgrounds and effects to match your vision.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Immersive Visuals",
            description:
              "Seamless green screen integration for professional results.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Efficient production to meet your deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Videos optimized for social media, websites, or events.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for green screen production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From filming to post-production, we handle it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Green Screen Video Production Process"
        description={
          <Description>
            We create dynamic green screen videos through a streamlined,
            creative process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your goals, audience, and creative
                vision.
              </li>
              <li>
                Planning: Develop a script or storyboard with background
                concepts.
              </li>
              <li>
                Setup: Configure professional green screen lighting and
                equipment.
              </li>
              <li>
                Filming: Capture high-quality footage with precise camera work.
              </li>
              <li>
                Post-Production: Replace green screen with custom visuals, add
                effects, and edit.
              </li>
              <li>
                Delivery: Provide a polished video ready for your platforms.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Green screen studio
          "https://images.unsplash.com/photo-1581508473129-921253588f0e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production crew
          "https://images.unsplash.com/photo-1578470517985-24638408d1ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Post-production editing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Green Screen Video Wins in Al Barsha"
        description="Our green screen videos have driven engagement and impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Virtual Event",
            description:
              "Produced an immersive virtual conference with custom backgrounds.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Product Promo",
            description:
              "Created a dynamic commercial with seamless visual effects.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from green screen video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Dynamic Videos?</Subheading>}
        heading="Green Screen Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional green screen video
            production in Al Barsha. Create immersive, high-quality videos that
            bring your vision to life—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production crew
          "https://images.unsplash.com/photo-1619468129361-605ebea04b44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Post-production editing
          "https://images.unsplash.com/photo-1514302240736-b1fee5985889?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Green screen studio
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
